function loadFacebookShareCount(id, url, escapedUrl) {
  $.getJSON('https://graph.facebook.com/?ids=' + escapedUrl, function(data) {
    $('#' + id + ' .facebook .count').append(data[url]['shares'] || 0);
  });
}

function loadTwitterShareCount(id, escapedUrl) {
  $.getJSON("https://urls.api.twitter.com/1/urls/count.json?url="+ escapedUrl +"+&callback=?", function(data) {
    $('#' + id + ' .twitter .count').append('<a style="color:black" target="_blank" href="http://twitter.com/search?q=" + escapedUrl>' + data['count'] + '</a>');
  });
}


/*** EXPORTS FROM exports-loader ***/
exports["loadFacebookShareCount"] = (loadFacebookShareCount);
exports["loadTwitterShareCount"] = (loadTwitterShareCount);